import ContentSlider from './ContentSlider'

export default ContentSlider
